// extracted by mini-css-extract-plugin
module.exports = {"Section":"PlaybackSection-style__Section--1fw3v","Button":"PlaybackSection-style__Button--3QBQs"};